import React, { useEffect, useState } from "react";
import { X, ArrowRight } from "lucide-react";
import { useCMS } from "../context/CMSContext";

export default function Popup() {
  const { cms } = useCMS();
  const popup = cms?.popup;
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!popup?.enabled) return;
    const dismissed = sessionStorage.getItem("lm_popup_dismissed");
    if (dismissed) return;
    if (popup.trigger === "load") {
      setOpen(true);
    } else if (popup.trigger === "delay") {
      const t = setTimeout(() => setOpen(true), (popup.delay_seconds || 5) * 1000);
      return () => clearTimeout(t);
    } else if (popup.trigger === "exit") {
      const handler = (e) => {
        if (e.clientY < 5) setOpen(true);
      };
      document.addEventListener("mouseleave", handler);
      return () => document.removeEventListener("mouseleave", handler);
    }
  }, [popup]);

  const close = () => {
    setOpen(false);
    sessionStorage.setItem("lm_popup_dismissed", "1");
  };

  if (!popup?.enabled || !open) return null;

  return (
    <div className="fixed inset-0 z-[60] bg-black/60 backdrop-blur-sm flex items-center justify-center p-4" onClick={close}>
      <div
        className="relative w-full max-w-md bg-white rounded-3xl overflow-hidden shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={close}
          className="absolute top-3 right-3 z-10 w-8 h-8 rounded-full bg-white/90 hover:bg-white text-[#11151C] flex items-center justify-center shadow"
          aria-label="Close"
        >
          <X className="w-4 h-4" />
        </button>
        {popup.image_url && (
          <div className="aspect-[16/9] bg-gradient-to-br from-[#FFE6D6] to-[#FFD0B8] overflow-hidden">
            <img src={popup.image_url} alt="" className="w-full h-full object-cover" />
          </div>
        )}
        <div className="p-7 text-center">
          {!popup.image_url && (
            <div className="mx-auto mb-4 w-14 h-14 rounded-full bg-gradient-to-br from-[#FFE6D6] to-[#FFD0B8] flex items-center justify-center">
              <span className="text-2xl">🎉</span>
            </div>
          )}
          <h3 className="lm-font font-extrabold text-[#11151C] text-2xl">{popup.title}</h3>
          <p className="text-[#11151C]/70 mt-3 text-sm sm:text-base leading-relaxed">{popup.description}</p>
          {popup.cta_text && (
            <a
              href={popup.cta_url || "#pricing"}
              onClick={close}
              className="lm-btn-primary mt-6 inline-flex items-center gap-2 px-5 py-3 rounded-xl font-bold text-sm"
            >
              {popup.cta_text} <ArrowRight className="w-4 h-4" />
            </a>
          )}
        </div>
      </div>
    </div>
  );
}
